/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const getPlatformAndroidapkTestTable = params => {
  return axios.post(`${base}/query_android_apk`, params)
}
export const getPlatformAndroidapkTestDetail = params => {
  return axios.get(`${base}/get_android_apk_${params.id}`, {params})
}
export const exportPlatformAndroidapkTestData = params => {
  return axios.get(`${base}/exportPlatformAndroidapkTestData/${params.id}`, {params})
}
export const createPlatformAndroidapkTestData = params => {
  return axios.post(`${base}/creat_android_apk`, params)
}
export const updatePlatformAndroidapkTestData = params => {
  return axios.post(`${base}/edit_android_apk_${params.id}`, params)
}
export const deletePlatformAndroidapkTestData = params => {
  return axios.post(`${base}/delete_android_apk_${params.id}`, params)
}
export const uploadApkFile = params => {
  return axios.post(`${base}/upload_android_apk`, params)
}
export const getAndroidApkSignedUrl = params => {
  return axios.post(`${base}/get_android_apk_signed_url`, params)
}



// WEBPACK FOOTER //
// ./src/views/platform-androidapk-test/platform-androidapk-test.api.js